import React, { useState, useRef, useEffect } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { FaHome, FaRegEdit, FaRocketchat, FaShoppingCart, FaWallet } from 'react-icons/fa';
import Logo from '../Assets/Logo.png'
import { MdBookmarkBorder, MdEditNote, MdFeedback, MdLiveHelp, MdMenuBook, MdNewspaper, MdOutlineQuiz, MdOutlineWidgets, MdOutlineWorkspacePremium, MdSportsScore } from 'react-icons/md';
import { RiLiveLine, RiMenuFoldFill } from 'react-icons/ri';
import { HiSupport } from 'react-icons/hi';
import { LuLogOut, LuNewspaper } from 'react-icons/lu';
import { TfiPackage } from "react-icons/tfi";
import DashBoard from './student-dashboard/Dashboard';
import '../Studentadmin/student-dashboard/Dashboard.css'
import { IoIosNotifications, IoMdPaper } from 'react-icons/io';
import { BASE_URL, IMGAGE_URL } from '../Config';
import axios from 'axios';
import StudentProfile from './profile/Profile';
import { Link, useNavigate } from 'react-router-dom';
import '../App.css'
import { FaQuestion, FaUser } from 'react-icons/fa6';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { CiLogin, CiUser, CiWallet } from 'react-icons/ci';
import { BiSupport } from 'react-icons/bi';
import { AiOutlineDatabase, AiOutlineHome } from 'react-icons/ai';
import { PiStudent, PiSubtitlesFill } from 'react-icons/pi';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';


import Divider from '@mui/material/Divider';
import {
    MdDashboard,
    MdNote,
    MdPerson,
    MdHelpOutline,
    MdArrowDropDown,
} from 'react-icons/md';

const drawerWidth = 260;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    overflowX: 'hidden',
    // Hide the scrollbar
    '&::-webkit-scrollbar': {
        display: 'none',
    },
    '-ms-overflow-style': 'none',  // For Internet Explorer and Edge
    'scrollbar-width': 'none',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

export default function Sutentdashboard() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const theme = useTheme();
    const userdatatoken = localStorage.getItem('userDatatoken');
    const token = localStorage.getItem('token_type');
    const [open, setOpen] = React.useState(true);
    const [selectedContent, setSelectedContent] = React.useState("dashboard");
    const navigate = useNavigate();
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };
    const handleListItemClick = (content) => {
        setSelectedContent(content);
        navigate(`/${content}`);
        setShow(false)
    };

    useEffect(() => {
        // Fetch profile data when the component mounts
        fetchProfileData();
    }, []);
    const [userdata1, setUserdata1] = useState('')
    const tokenid = 'Bearer' + userdatatoken
    const tokendata = tokenid.replace(/"/g, ' ');
    // console.log(tokendata)
    const fetchProfileData = async () => {
        axios.get(BASE_URL + 'profiles', {
            headers: {
                Accept: "application/json",
                Authorization: tokendata

            }
        }).then(({ data }) => {
            setUserdata1(data.data)
            localStorage.setItem('userData', JSON.stringify(data.data));
        })
    };

    const userdata = localStorage.getItem('userData');
    const [notificationdata, setNotificationdata] = useState([])
    useEffect(() => {
        fetchnotificationData();

    }, []);

    const fetchnotificationData = async () => {

        try {
            const res = await axios.get(`${BASE_URL}notifications`, {
                headers: { Accept: "application/json", Authorization: tokendata }
            });

            if (res.data && res.data) {
                setNotificationdata(res.data.notifications)
            } else {
                setNotificationdata([]);
            }

        } catch (err) {
            console.error(err);

        }
    };
    const unreadCount = notificationdata.filter(n => n.is_read === 0).length;
    console.log(unreadCount)

    const [openItem, setOpenItem] = useState(null); // State to track the open list item

    // Function to handle clicking on a list item
    const handleListItemClick1 = (item) => {
        setOpenItem(openItem === item ? null : item); // Toggle the open status
    };
    const url = window.location.pathname
    const pathurl = url.substring(1);
    const removelocaldata = () => {
        localStorage.clear();

        navigate('/')
        window.location.reload();
    }
    // const [notification, setNotification] = useState(false)
    // const opennotification = () => {
    //     setNotification(true)
    // }
    // const closenotification = () => {
    //     setNotification(false)
    // }
    const profileDropdownStyles = {
        container: {
            position: "relative",
        },
        menu: {
            position: "absolute",
            top: "120%",
            right: 0,
            background: "#fff",
            width: "220px",
            padding: "10px 0",
            borderRadius: "12px",
            boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            border: "1px solid #e6e6e6",
            display: "none",
            zIndex: 9999,
        },
        arrow: {
            position: "absolute",
            top: "-8px",
            right: "22px",
            width: 0,
            height: 0,
            borderLeft: "8px solid transparent",
            borderRight: "8px solid transparent",
            borderBottom: "8px solid white",
            filter: "drop-shadow(0px -1px 1px rgba(0,0,0,0.1))",
        },
        item: {
            padding: "12px 18px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            fontSize: "15px",
            cursor: "pointer",
            color: "#333",
            transition: "0.2s",
        },
    };
    const openProfileMenu = (e) => {
        e.stopPropagation();
        const menu = document.getElementById("profile-dropdown-menu");
        menu.style.display = menu.style.display === "block" ? "none" : "block";
    };

    // outside click close
    document.addEventListener("click", () => {
        const menu = document.getElementById("profile-dropdown-menu");
        if (menu) menu.style.display = "none";
    });

    const toggleMenu = (e, id) => {
        e.stopPropagation();

        // close any open menus
        document.querySelectorAll(".custom-open").forEach(m => {
            if (m.id !== id) m.style.display = "none";
        });

        const menu = document.getElementById(id);
        menu.style.display = menu.style.display === "block" ? "none" : "block";
        menu.classList.add("custom-open");
    };

    // Close dropdown on outside click
    document.addEventListener("click", () => {
        document.querySelectorAll(".custom-open").forEach(m => {
            m.style.display = "none";
        });
    });
    const menuBox = {
        background: "#fff",
        border: "1px solid #e5e5e5",
        padding: "18px 10px",
        textAlign: "center",
        borderRadius: "8px",
        cursor: "pointer",
        transition: "0.2s",
    };

    const menuIcon = {
        width: "45px",
        height: "45px",
        background: "#f2f4f7",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 8px",
    };

    const menuText = {
        fontSize: "14px",
        fontWeight: "600",
        color: "#444",
        margin: 0,
    };


    const [showNotifications, setShowNotifications] = useState(false);
    const notifRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (notifRef.current && !notifRef.current.contains(e.target)) {
                setShowNotifications(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    const getTimeAgo = (dateString) => {
        const now = new Date();

        // Convert "16 Jan 2026 02:42 PM" → Date
        const notificationDate = new Date(dateString.replace(/(\d{2}) (\w{3}) (\d{4})/, '$2 $1, $3'));

        const diffMs = now - notificationDate;
        const diffSeconds = Math.floor(diffMs / 1000);
        const diffMinutes = Math.floor(diffSeconds / 60);
        const diffHours = Math.floor(diffMinutes / 60);
        const diffDays = Math.floor(diffHours / 24);

        // 🔹 Just now
        if (diffSeconds < 60) return "Just now";

        // 🔹 Minutes
        if (diffMinutes < 60)
            return `${diffMinutes} min${diffMinutes > 1 ? "s" : ""} ago`;

        // 🔹 Hours (same day)
        if (diffHours < 24)
            return `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;

        // 🔹 Yesterday
        if (diffDays === 1) return "Yesterday";

        // 🔹 Days (within a week)
        if (diffDays < 7)
            return `${diffDays} days ago`;

        // 🔹 Weeks
        const weeks = Math.floor(diffDays / 7);
        if (weeks < 4)
            return `${weeks} week${weeks > 1 ? "s" : ""} ago`;

        // 🔹 Older dates → show full date
        return `On ${notificationDate.toDateString()}`;
    };

    const truncateWords = (text, limit = 30) => {
        if (!text) return "";

        const words = text.split(" ");
        if (words.length <= limit) return text;

        return words.slice(0, limit).join(" ") + "...";
    };

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseancher = () => {
        setAnchorEl(null);
    };

    return (
        <div className=''>
            <div className='mobile-header-dashboard'>
                <div className="topadmin-header">
                    <div className="admin-nav-row">
                        <Link to="/" className="nav-item" style={{ border: "1px solid #fff", padding: "7px 7px", borderRadius: "3px" }}>
                            <AiOutlineHome style={{ marginTop: "-4px", fontSize: "16px" }} /> Home
                        </Link>
                        {/* | */}
                        {/* <Link to="/wallet" className="nav-item">
                            <CiWallet style={{ marginTop: "-4px", fontSize: "16px" }} /> Wallet
                        </Link> */}
                        {/* | */}
                        {/* <button onClick={handleShow} className="nav-item">
                            <PiStudent style={{ marginTop: "-4px", fontSize: "16px" }} /> Student Center
                        </button>
                        | */}
                        <div className='top-header-text-admin'>
                            {/* <h6>Monday, Jan 12th, 10:30 AM</h6> */}
                            {/* <Link to={"/"}>
                            <h6 style={{ color: "#373737", background: "#8080804f", padding: "5px 10px", borderRadius: "3px", fontWeight: "600", margin: "0" }}>Home</h6>
                        </Link> */}
                            {/* <h4 style={{ backgroundColor: "#80808026", padding: "5px 8px", borderRadius: "50%",margin:"0" }}><MdOutlineWidgets /></h4> */}
                            <div style={{ position: "relative" }} ref={notifRef}>
                                <div className="notif-bell-wrapper">
                                    <div className="notif-bell-wrapper">
                                        <h2 className='m-0'
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setShowNotifications(!showNotifications)}
                                        >
                                            <IoIosNotifications />
                                        </h2>

                                        {unreadCount > 0 && (
                                            <span className="notif-badge">
                                                {unreadCount}
                                            </span>
                                        )}
                                    </div>


                                    {unreadCount > 0 && (
                                        <span className="notif-badge">
                                            {unreadCount}
                                        </span>
                                    )}
                                </div>


                                {showNotifications && (
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "40px",
                                            right: "0",
                                            width: "220px",
                                            background: "#fff",
                                            borderRadius: "8px",
                                            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                                            zIndex: 1000,
                                            overflow: "hidden",
                                        }}
                                    >
                                        {/* Header */}
                                        <div
                                            style={{
                                                padding: "12px 16px",
                                                borderBottom: "1px solid #eee",
                                                fontWeight: "600",
                                                fontSize: "15px",
                                            }}
                                        >
                                            Notifications
                                        </div>

                                        {/* Notification Items */}
                                        <div style={{ maxHeight: "260px", overflowY: "auto" }}>
                                            {notificationdata.map((e, index) => (
                                                <div className={`notif-item ${e.is_read === 0 ? "unread" : ""}`} key={index}>

                                                    {/* Left Icon / Image */}
                                                    {/* <div className="notif-icon">
                                                    {e.attachment == null ? <IoIosNotifications style={{ fontSize: "30px" }} /> : <img
                                                        src={e.attachment}
                                                        alt="notification"
                                                    />}

                                                </div> */}

                                                    {/* Right Content */}
                                                    <div className="notif-content">
                                                        <strong className="notif-title">
                                                            {truncateWords(e.title, 10)}
                                                        </strong>

                                                        {/* <p className="notif-text">
                                                        {truncateWords(e.content, 15)}
                                                    </p> */}

                                                        <span className="notif-time">
                                                            {getTimeAgo(e.date)}
                                                        </span>
                                                    </div>

                                                </div>
                                            ))}



                                        </div>

                                        {/* Footer */}
                                        <div
                                            style={{
                                                padding: "10px",
                                                textAlign: "center",
                                                borderTop: "1px solid #eee",
                                                cursor: "pointer",
                                                fontWeight: "500",
                                                color: "#dc3545",
                                            }}
                                        >
                                            View All Notifications
                                        </div>
                                    </div>
                                )}
                            </div>


                            {userdata == null ? (
                                <div className="profileicondropdown-wrapper">
                                    <IconButton
                                        onClick={handleClick}
                                        size="small"
                                        className="profileicondropdown-btn"
                                    >
                                        <div className="profileicondropdown-img-container">
                                            <img
                                                src="https://images.pexels.com/photos/414612/pexels-photo-414612.jpeg?cs=srgb&dl=pexels-james-wheeler-414612.jpg&fm=jpg"
                                                alt="Profile"
                                                className="profileicondropdown-img"
                                            />
                                            <MdArrowDropDown className="profileicondropdown-arrow" />
                                        </div>
                                    </IconButton>

                                    <Menu
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={handleCloseancher}
                                        PaperProps={{
                                            elevation: 6,
                                            sx: {
                                                mt: 1.5,
                                                minWidth: 200,
                                                borderRadius: '10px',
                                                overflow: 'hidden',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
                                            },
                                        }}
                                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                    >
                                        <MenuItem
                                            onClick={handleCloseancher}
                                            component={Link}
                                            to="/log-in"
                                            className="profileicondropdown-menuitem"
                                        >
                                            <ListItemIcon>
                                                <MdPerson fontSize="20px" />
                                            </ListItemIcon>
                                            <ListItemText>Login / Signup</ListItemText>
                                        </MenuItem>
                                    </Menu>
                                </div>
                            ) : (
                                <div className="profileicondropdown-wrapper">
                                    <IconButton
                                        onClick={handleClick}
                                        size="small"
                                        className="profileicondropdown-btn"
                                    >
                                        <div className="profileicondropdown-img-container">

                                            {userdata1?.image ? (
                                                <img
                                                    src={IMGAGE_URL + userdata1.image}
                                                    alt="Profile"
                                                    className="profileicondropdown-img"
                                                />
                                            ) : (
                                                <div className="profileicondropdown-fallback">
                                                    {userdata1?.name?.charAt(0)?.toUpperCase() || "U"}
                                                </div>
                                            )}

                                            <MdArrowDropDown className="profileicondropdown-arrow" style={{ color: "#fff" }} />
                                        </div>

                                    </IconButton>

                                    <Menu
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={handleCloseancher}
                                        PaperProps={{
                                            elevation: 6,
                                            sx: {
                                                mt: 1.5,
                                                minWidth: 220,
                                                borderRadius: '10px',
                                                overflow: 'hidden',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
                                            },
                                        }}
                                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                    >
                                        <MenuItem
                                            onClick={handleCloseancher}
                                            component={Link}
                                            to="/student-admin"
                                            className="profileicondropdown-menuitem"
                                        >
                                            <ListItemIcon>
                                                <MdDashboard fontSize="20px" />
                                            </ListItemIcon>
                                            <ListItemText primary="Student Dashboard" />
                                        </MenuItem>

                                        <MenuItem
                                            onClick={handleCloseancher}
                                            component={Link}
                                            to="/my-notes"
                                            className="profileicondropdown-menuitem"
                                        >
                                            <ListItemIcon>
                                                <MdNote fontSize="20px" />
                                            </ListItemIcon>
                                            <ListItemText primary="My Notes" />
                                        </MenuItem>

                                        <MenuItem
                                            onClick={handleCloseancher}
                                            component={Link}
                                            to="/student-profile"
                                            className="profileicondropdown-menuitem"
                                        >
                                            <ListItemIcon>
                                                <MdPerson fontSize="20px" />
                                            </ListItemIcon>
                                            <ListItemText primary="Profile" />
                                        </MenuItem>

                                        <Divider sx={{ my: 0.5 }} />

                                        <MenuItem
                                            onClick={handleCloseancher}
                                            component={Link}
                                            to="/help-support"
                                            className="profileicondropdown-menuitem"
                                        >
                                            <ListItemIcon>
                                                <MdHelpOutline fontSize="20px" />
                                            </ListItemIcon>
                                            <ListItemText primary="Help & Support" />
                                        </MenuItem>


                                    </Menu>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
                <div className='mobile-header-dashboard-top'>
                    <DrawerHeader style={{ paddingBottom: "3px" }}>
                        <Link to={"/"}>
                            <img src={Logo} alt='img' style={{ width: "140px", margin: "auto" }} />
                        </Link>

                    </DrawerHeader>
                    <button onClick={handleShow} className="nav-item" style={{ color: "#000", fontSize: "20px" }}>
                        <RiMenuFoldFill style={{ marginTop: "-4px", fontSize: "22px" }} /> Student Corner
                    </button>

                </div>


            </div>
            <Offcanvas show={show} onHide={handleClose}>
                <Offcanvas.Header closeButton >
                    <Offcanvas.Title><Link to={"/"}>
                        <img src={Logo} alt='img' style={{ width: "125px", margin: "auto" }} />
                    </Link></Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body style={{ paddingTop: "0px;" }}>



                    <List sx={{ p: 0, pt: 2 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "student-admin" ? "#8080801c" : "none",
                                    // color: pathurl === "student-admin" ? "#FFF": "none"
                                }}
                                onClick={() => handleListItemClick("student-admin")}
                                className={pathurl === "student-admin" ? "admintbbutton" : "adminselectedbutton"}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <FaHome />
                                </ListItemIcon>
                                <ListItemText style={{ fontSize: "12px" }} primary={"DashBoard"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>
                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "student-profile" ? "#8080801c" : "none"
                                }}
                                onClick={() => handleListItemClick("student-profile")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <FaUser />
                                </ListItemIcon>
                                <ListItemText primary={"Profile"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "order" ? "#8080801c" : "none"

                                }}
                                onClick={() => handleListItemClick1("order")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <MdEditNote />
                                </ListItemIcon>
                                <ListItemText primary={"Orders & Subscriptions"} sx={{ opacity: open ? 1 : 0 }} />
                                <ExpandMoreIcon
                                    sx={{
                                        transform: openItem === "order" ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.3s ease',
                                        marginLeft: 'auto'
                                    }}
                                />
                            </ListItemButton>
                            {openItem === "order" && (
                                <div className='testseries-subcategory-drawer' style={{ marginLeft: "30px" }}>
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "orders" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("orders")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <MdBookmarkBorder />
                                                </ListItemIcon>
                                                <ListItemText primary={"My Orders"} sx={{ opacity: open ? 1 : 0 }} />

                                            </ListItemButton>
                                        </ListItem>

                                    </List>


                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "subscription" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("subscription")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <PiSubtitlesFill />
                                                </ListItemIcon>
                                                <ListItemText primary={"My Subscription"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                </div>
                            )}
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "notes" ? "#8080801c" : "none"
                                }}
                                onClick={() => handleListItemClick("notes")}

                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <FaRegEdit />
                                </ListItemIcon>
                                <ListItemText primary={"My Notes"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>
                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "quiz" ? "#8080801c" : "none"
                                }}
                                onClick={() => handleListItemClick("quiz")}

                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <MdOutlineQuiz />
                                </ListItemIcon>
                                <ListItemText primary={"My Quiz"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "series" ? "#8080801c" : "none"

                                }}
                                onClick={() => handleListItemClick1("series")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <MdEditNote />
                                </ListItemIcon>
                                <ListItemText primary={"Test Series & Results"} sx={{ opacity: open ? 1 : 0 }} />
                                <ExpandMoreIcon
                                    sx={{
                                        transform: openItem === "series" ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.3s ease',
                                        marginLeft: 'auto'
                                    }}
                                />
                            </ListItemButton>
                            {openItem === "series" && (
                                <div className='testseries-subcategory-drawer' style={{ marginLeft: "30px" }}>
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "package-test-series" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("package-test-series")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <LuNewspaper />
                                                </ListItemIcon>
                                                <ListItemText primary={"Test Series"} sx={{ opacity: open ? 1 : 0 }} />

                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                    {/* <List sx={{ p: 0 }}>

                                    <ListItem disablePadding sx={{ display: 'block' }}>
                                        <ListItemButton
                                            sx={{
                                                minHeight: 48,
                                                justifyContent: open ? 'initial' : 'center',
                                                px: 2.5,
                                                backgroundColor: pathurl === "package-details" ? "#8080801c" : "none"
                                            }}
                                            onClick={() => handleListItemClick("package-details")}
                                        >
                                            <ListItemIcon
                                                sx={{
                                                    minWidth: 0,
                                                    mr: open ? 3 : 'auto',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <RiLiveLine />
                                            </ListItemIcon>
                                            <ListItemText primary={"Package Details"} sx={{ opacity: open ? 1 : 0 }} />
                                        </ListItemButton>
                                    </ListItem>

                                </List> */}
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "start-test" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("start-test")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <MdNewspaper />
                                                </ListItemIcon>
                                                <ListItemText primary={"Test Paper"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "test-results" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("test-results")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <AiOutlineDatabase />
                                                </ListItemIcon>
                                                <ListItemText primary={"Test Results"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                </div>
                            )}
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "liveclasses" ? "#8080801c" : "none"
                                }}
                                // onClick={() => handleListItemClick1("liveclasses")}
                                 onClick={() => handleListItemClick("live-classes-package-details")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <RiLiveLine />
                                </ListItemIcon>
                                <ListItemText primary={"Live Classes"} sx={{ opacity: open ? 1 : 0 }} />
                                {/* <ExpandMoreIcon
                                    sx={{
                                        transform: openItem === "liveclasses" ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.3s ease',
                                        marginLeft: 'auto'
                                    }}
                                /> */}
                            </ListItemButton>
                            {openItem === "liveclasses" && (
                                <div className='testseries-subcategory-drawer' style={{ marginLeft: "30px" }}>
                                    {/* <List sx={{ p: 0 }}>

                                    <ListItem disablePadding sx={{ display: 'block' }}>
                                        <ListItemButton
                                            sx={{
                                                minHeight: 48,
                                                justifyContent: open ? 'initial' : 'center',
                                                px: 2.5,
                                                backgroundColor: pathurl === "package-test-series" ? "#8080801c" : "none"
                                            }}
                                            onClick={() => handleListItemClick("live-class")}
                                        >
                                            <ListItemIcon
                                                sx={{
                                                    minWidth: 0,
                                                    mr: open ? 3 : 'auto',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <RiLiveLine />
                                            </ListItemIcon>
                                            <ListItemText primary={"Live Classes"} sx={{ opacity: open ? 1 : 0 }} />
                                        </ListItemButton>
                                    </ListItem>

                                </List> */}
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "live-classes-package-details" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("live-classes-package-details")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <TfiPackage />
                                                </ListItemIcon>
                                                <ListItemText primary={"Package Details"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "test-results" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("live-class-manage-schedule")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <RiLiveLine />
                                                </ListItemIcon>
                                                <ListItemText primary={"Class & Schedule"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                    {/* <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "call-history" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("call-history")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <RiLiveLine />
                                                </ListItemIcon>
                                                <ListItemText primary={"Previous Classes"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List> */}


                                </div>
                            )}
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "teacheroncall" ? "#8080801c" : "none"
                                }}
                                // onClick={() => handleListItemClick1("teacheroncall")}
                                onClick={() => handleListItemClick("teacheroncall/package-details")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <FaRocketchat />
                                </ListItemIcon>
                                <ListItemText primary={"Teacher on Calls"} sx={{ opacity: open ? 1 : 0 }} />
                                {/* <ExpandMoreIcon
                                    sx={{
                                        transform: openItem === "teacheroncall" ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.3s ease',
                                        marginLeft: 'auto'
                                    }}
                                /> */}
                            </ListItemButton>
                            {openItem === "teacheroncall" && (
                                <div className='testseries-subcategory-drawer' style={{ marginLeft: "30px" }}>

                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "package-details" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("teacheroncall/package-details")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <RiLiveLine />
                                                </ListItemIcon>
                                                <ListItemText primary={"Package Details"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "test-paper" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("teacheroncall/call-history")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <RiLiveLine />
                                                </ListItemIcon>
                                                <ListItemText primary={"Call History"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>

                                </div>
                            )}
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "interview-package-details" ? "#8080801c" : "none"
                                }}
                                // onClick={() => handleListItemClick1("interview")}
                                onClick={() => handleListItemClick("interview-package-details")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <MdLiveHelp />
                                </ListItemIcon>
                                <ListItemText primary={"Interviews"} sx={{ opacity: open ? 1 : 0 }} />
                                {/* <ExpandMoreIcon
                                    sx={{
                                        transform: openItem === "interview" ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.3s ease',
                                        marginLeft: 'auto'
                                    }}
                                /> */}
                            </ListItemButton>
                            {openItem === "interview" && (
                                <div className='testseries-subcategory-drawer' style={{ marginLeft: "30px" }}>
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "package-test-series" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("interview-package-details")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <RiLiveLine />
                                                </ListItemIcon>
                                                <ListItemText primary={"Package Details"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                    {/* <List sx={{ p: 0 }}>

                                    <ListItem disablePadding sx={{ display: 'block' }}>
                                        <ListItemButton
                                            sx={{
                                                minHeight: 48,
                                                justifyContent: open ? 'initial' : 'center',
                                                px: 2.5,
                                                backgroundColor: pathurl === "package-details" ? "#8080801c" : "none"
                                            }}
                                            onClick={() => handleListItemClick("manage-sechedule")}
                                        >
                                            <ListItemIcon
                                                sx={{
                                                    minWidth: 0,
                                                    mr: open ? 3 : 'auto',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <RiLiveLine />
                                            </ListItemIcon>
                                            <ListItemText primary={"Manage Schedule"} sx={{ opacity: open ? 1 : 0 }} />
                                        </ListItemButton>
                                    </ListItem>

                                </List> */}
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "test-paper" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("my-interview")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <RiLiveLine />
                                                </ListItemIcon>
                                                <ListItemText primary={"My Interviews"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "test-results" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("interview-history")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <RiLiveLine />
                                                </ListItemIcon>
                                                <ListItemText primary={"Interview History"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                </div>
                            )}
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "wallet" ? "#8080801c" : "none"
                                }}
                                onClick={() => handleListItemClick("wallet")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <FaWallet />
                                </ListItemIcon>
                                <ListItemText primary={"Wallet"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "My-Referral" ? "#8080801c" : "none"
                                }}
                                onClick={() => handleListItemClick("My-Referral")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <FaWallet />
                                </ListItemIcon>
                                <ListItemText primary={"My Referral"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "feedback" ? "#8080801c" : "none"
                                }}
                                onClick={() => handleListItemClick("feedback")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <MdFeedback />
                                </ListItemIcon>
                                <ListItemText primary={"Feedback and Reviews"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "help-support" ? "#8080801c" : "none"
                                }}
                                onClick={() => handleListItemClick("help-support")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <HiSupport />
                                </ListItemIcon>
                                <ListItemText primary={"Help & Support"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>



                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    // backgroundColor: pathurl === "student-profile" ? "#8080801c": "none"
                                }}
                                onClick={() => removelocaldata()}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <LuLogOut />
                                </ListItemIcon>
                                <ListItemText primary={"Logout"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>



                </Offcanvas.Body>
            </Offcanvas>


            <Box className="desktop-header-dashboard" sx={{ display: 'flex' }}>
                <CssBaseline />

                <AppBar position="fixed" open={open} style={{ backgroundColor: "#ffffff", color: "gray", boxShadow: "none", borderBottom: "1px solid #80808033" }}>

                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                            sx={{
                                marginRight: 5,
                                ...(open && { display: 'none' }),
                            }}
                        >

                            <MenuIcon />
                        </IconButton>

                        <div className='dashboard--top--header'>
                            <div className='desktop-togglemenu m-0'>

                                <IconButton sx={{
                                    marginRight: 5,
                                    ...(open && { display: 'none' }),
                                }} onClick={handleDrawerClose}>
                                    {theme.direction === 'rtl' ? <MenuIcon /> : <MenuIcon />}
                                </IconButton>
                            </div>
                            <div className='m-0 mobile-togglemenu'>

                                <IconButton sx={{
                                    marginRight: 5,
                                    ...(!open && { display: 'none' }),
                                }} onClick={handleDrawerClose}>
                                    {theme.direction === 'rtl' ? <MenuIcon /> : <MenuIcon />}
                                </IconButton>
                            </div>
                            <div className='top-header-text-admin' style={{ display: "flex", alignItems: "center", gap: "20px" }}>

                                {/* Go Back */}
                                <a href={"/"}
                                    style={{ textDecoration: "none" }}
                                >
                                    <h6
                                        style={{
                                            color: "#666666",
                                            backgroundColor: "#f9f9f9",
                                            height:"42px",
                                            padding: "10px 15px",
                                            borderRadius: "3px",
                                            fontWeight: "500",
                                            transition: "0.2s ease",
                                            cursor: "pointer",
                                            marginTop:"10px",
                                            border:"1px solid #666666",
                                             margin:"0px"
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.background = "#e91e20 ";
                                            e.target.style.color = "#fff";
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0px 2px 6px rgba(0,0,0,0.2)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.background = "#f9f9f9";
                                            e.target.style.color = "#666666";
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        Go Back to Home
                                    </h6>
                                </a>


                                {/* Widgets Dropdown */}
                                <div style={{ position: "relative" }}>
                                    <h4
                                        onClick={(e) => toggleMenu(e, "widgets-grid-menu")}
                                        style={{
                                            backgroundColor: "#f9f9f9",
                                            padding: "5px 8px",
                                            borderRadius: "50%",
                                            height:"42px",
                                            width:"42px",
                                            cursor: "pointer",
                                            display:"flex",
                                            justifyContent:"center",
                                            alignItems:"center",
                                            margin:"0px",
                                             border:"1px solid #666666",

                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.background = "#e91e20 ";
                                            e.target.style.color = "#fff";
                                            e.target.style.transform = "translateY(-2px)";
                                            
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.background = "#f9f9f9";
                                            e.target.style.color = "#666666";
                                            e.target.style.transform = "translateY(0px)";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    >
                                        <MdOutlineWidgets />
                                    </h4>

                                    {/* GRID MENU */}
                                    <div
                                        id="widgets-grid-menu"
                                        style={{
                                            position: "absolute",
                                            top: "120%",
                                            right: 0,
                                            backgroundColor: "#fff",
                                            boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
                                            borderRadius: "10px",
                                            padding: "20px",
                                            width: "320px",
                                            display: "none",
                                            zIndex: 9999
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "repeat(2, 1fr)",
                                                gap: "15px"
                                            }}
                                        >
                                            {/* 1 - Test Papers */}
                                            <div style={menuBox} onClick={() => navigate("/start-test")}>
                                                <div style={menuIcon}>
                                                    <IoMdPaper style={{ fontSize: "26px", color: "#0d6efd" }} />

                                                </div>
                                                <p style={menuText}>Test Papers</p>
                                            </div>

                                            {/* 2 - Live Class Schedule */}
                                            <div style={menuBox} onClick={() => navigate("/live-class-manage-schedule")}>
                                                <div style={menuIcon}>
                                                    <RiLiveLine style={{ fontSize: "26px", color: "#198754" }} />

                                                </div>
                                                <p style={menuText}>Live Class Schedule</p>
                                            </div>

                                            {/* 3 - My Notes */}
                                            <div style={menuBox} onClick={() => navigate("/notes")}>
                                                <div style={menuIcon}>
                                                    <MdEditNote style={{ fontSize: "26px", color: "#0d6efd" }} />

                                                </div>
                                                <p style={menuText}>My Notes</p>
                                            </div>

                                            {/* 4 - Quiz Results */}
                                            <div style={menuBox} onClick={() => navigate("/quiz")}>
                                                <div style={menuIcon}>
                                                    <MdSportsScore style={{ fontSize: "26px", color: "#ff5722" }} />

                                                </div>
                                                <p style={menuText}>Quiz Results</p>
                                            </div>

                                            {/* 5 - Subscription */}
                                            <div style={menuBox} onClick={() => navigate("/subscription")}>
                                                <div style={menuIcon}>
                                                    <MdOutlineWorkspacePremium style={{ fontSize: "26px", color: "#6f42c1" }} />

                                                </div>
                                                <p style={menuText}>Subscription</p>
                                            </div>

                                            {/* 6 - Help & Support */}
                                            <div style={menuBox} onClick={() => navigate("/help-support")}>
                                                <div style={menuIcon}>
                                                    <BiSupport style={{ fontSize: "26px", color: "#0dcaf0" }} />

                                                </div>
                                                <p style={menuText}>Help & Support</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                {/* Notifications */}
                                <div style={{ position: "relative" }} ref={notifRef}>
                                    <div className="notif-bell-wrapper">
                                        <div className="notif-bell-wrapper">
                                            <h2
                                                style={{ cursor: "pointer" }}
                                                onClick={() => setShowNotifications(!showNotifications)}
                                            >
                                                <IoIosNotifications />
                                            </h2>
                                            {unreadCount > 0 && (
                                                <span className="notif-badge">
                                                    {unreadCount}
                                                </span>
                                            )}

                                            {/* {notificationdata.length > 0 && (
                                                <span className="notif-badge">
                                                    {notificationdata.length}
                                                </span>
                                            )} */}
                                        </div>


                                        {unreadCount > 0 && (
                                            <span className="notif-badge">
                                                {unreadCount}
                                            </span>
                                        )}
                                    </div>

                                    {showNotifications && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "40px",
                                                right: "0",
                                                width: "320px",
                                                background: "#fff",
                                                borderRadius: "8px",
                                                boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                                                zIndex: 1000,
                                                overflow: "hidden",
                                            }}
                                        >
                                            {/* Header */}
                                            <div
                                                style={{
                                                    padding: "12px 16px",
                                                    borderBottom: "1px solid #eee",
                                                    fontWeight: "600",
                                                    fontSize: "15px",
                                                }}
                                            >
                                                Notifications
                                            </div>

                                            {/* Notification Items */}
                                            <div style={{ maxHeight: "260px", overflowY: "auto" }}>
                                                {notificationdata.map((e, index) => (
                                                    <Link to={'/notification'}>
                                                        <div className={`notif-item ${e.is_read === 0 ? "unread" : ""}`} key={index}>

                                                            {/* Left Icon / Image */}
                                                            {/* <div className="notif-icon">
                                                            {e.attachment == null ? <IoIosNotifications style={{ fontSize: "30px" }} /> : <img
                                                                src={e.attachment}
                                                                alt="notification"
                                                            />}

                                                        </div> */}

                                                            {/* Right Content */}
                                                            <div className="notif-content">
                                                                <strong className="notif-title">
                                                                    {truncateWords(e.title, 10)}
                                                                </strong>

                                                                {/* <p className="notif-text">
                                                                {truncateWords(e.content, 15)}
                                                            </p> */}

                                                                <span className="notif-time">
                                                                    {getTimeAgo(e.date)}
                                                                </span>
                                                            </div>

                                                        </div>
                                                    </Link>
                                                ))}



                                            </div>

                                            {/* Footer */}
                                            <Link to={'/notification'}>
                                                <div
                                                    style={{
                                                        padding: "10px",
                                                        textAlign: "center",
                                                        borderTop: "1px solid #eee",
                                                        cursor: "pointer",
                                                        fontWeight: "500",
                                                        color: "#dc3545",
                                                    }}
                                                >
                                                    View All Notifications
                                                </div>
                                            </Link>
                                        </div>
                                    )}
                                </div>


                                <div style={profileDropdownStyles.container}>
                                    <img
                                        onClick={openProfileMenu}
                                        src={
                                            userdata == null
                                                ? "https://images.pexels.com/photos/414612/pexels-photo-414612.jpeg"
                                                : IMGAGE_URL + userdata1.image
                                        }
                                        style={{
                                            width: "42px",
                                            height: "42px",
                                            borderRadius: "50%",
                                            cursor: "pointer",
                                            objectFit: "cover",
                                        }}
                                        alt="profile"
                                    />

                                    {/* DROPDOWN MENU */}
                                    <div id="profile-dropdown-menu" style={profileDropdownStyles.menu}>
                                        <div style={profileDropdownStyles.arrow}></div>

                                        {/* PROFILE */}
                                        <div style={profileDropdownStyles.item} onClick={() => navigate("/student-profile")}>
                                            <CiUser />
                                            Profile
                                        </div>

                                        {/* DIVIDER */}
                                        <div
                                            style={{
                                                height: "1px",
                                                width: "100%",
                                                background: "#e8e8e8",
                                                margin: "4px 0",
                                            }}
                                        ></div>

                                        {/* FAQ */}
                                        <div style={profileDropdownStyles.item} onClick={() => navigate("/help-support")}>
                                            <BiSupport />
                                            Help & Support
                                        </div>



                                        {/* DIVIDER */}
                                        <div
                                            style={{
                                                height: "1px",
                                                width: "100%",
                                                background: "#e8e8e8",
                                                margin: "4px 0",
                                            }}
                                        ></div>

                                        {/* LOGOUT */}
                                        <div
                                            style={{ ...profileDropdownStyles.item, color: "red", fontWeight: "600" }}
                                            onClick={() => removelocaldata()}
                                        >
                                            <LuLogOut />
                                            Logout
                                        </div>
                                    </div>
                                </div>



                            </div>


                        </div>
                    </Toolbar>
                </AppBar>
                <Drawer variant="permanent" open={open}  >
                    <DrawerHeader style={{ borderBottom: "1px solid #80808033", paddingBottom: "3px", justifyContent: "flex-start" }}>
                        <Link to={"/"}>
                            <img src={Logo} alt='img' style={{ width: "155px", margin: "auto" }} />
                        </Link>

                    </DrawerHeader>

                    <List sx={{ p: 0, pt: 2 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "student-admin" ? "#8080801c" : "none",
                                    // color: pathurl === "student-admin" ? "#FFF": "none"
                                }}
                                onClick={() => handleListItemClick("student-admin")}
                                className={pathurl === "student-admin" ? "admintbbutton" : "adminselectedbutton"}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <FaHome />
                                </ListItemIcon>
                                <ListItemText style={{ fontSize: "12px" }} primary={"DashBoard"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>
                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "student-profile" ? "#8080801c" : "none"
                                }}
                                onClick={() => handleListItemClick("student-profile")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <FaUser />
                                </ListItemIcon>
                                <ListItemText primary={"Profile"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "order" ? "#8080801c" : "none"

                                }}
                                onClick={() => handleListItemClick1("order")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <MdEditNote />
                                </ListItemIcon>
                                <ListItemText primary={"Orders & Subscriptions"} sx={{ opacity: open ? 1 : 0 }} />
                                <ExpandMoreIcon
                                    sx={{
                                        transform: openItem === "order" ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.3s ease',
                                        marginLeft: 'auto'
                                    }}
                                />
                            </ListItemButton>
                            {openItem === "order" && (
                                <div className='testseries-subcategory-drawer' style={{ marginLeft: "30px" }}>
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "orders" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("orders")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <MdBookmarkBorder />
                                                </ListItemIcon>
                                                <ListItemText primary={"My Orders"} sx={{ opacity: open ? 1 : 0 }} />

                                            </ListItemButton>
                                        </ListItem>

                                    </List>


                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "subscription" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("subscription")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <PiSubtitlesFill />
                                                </ListItemIcon>
                                                <ListItemText primary={"My Subscription"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                </div>
                            )}
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "notes" ? "#8080801c" : "none"
                                }}
                                onClick={() => handleListItemClick("notes")}

                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <FaRegEdit />
                                </ListItemIcon>
                                <ListItemText primary={"My Notes"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>
                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "quiz" ? "#8080801c" : "none"
                                }}
                                onClick={() => handleListItemClick("quiz")}

                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <MdOutlineQuiz />
                                </ListItemIcon>
                                <ListItemText primary={"My Quiz"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "series" ? "#8080801c" : "none"

                                }}
                                onClick={() => handleListItemClick1("series")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <MdEditNote />
                                </ListItemIcon>
                                <ListItemText primary={"Test Series & Results"} sx={{ opacity: open ? 1 : 0 }} />
                                <ExpandMoreIcon
                                    sx={{
                                        transform: openItem === "series" ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.3s ease',
                                        marginLeft: 'auto'
                                    }}
                                />
                            </ListItemButton>
                            {openItem === "series" && (
                                <div className='testseries-subcategory-drawer' style={{ marginLeft: "30px" }}>
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "package-test-series" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("package-test-series")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <LuNewspaper />
                                                </ListItemIcon>
                                                <ListItemText primary={"Test Series"} sx={{ opacity: open ? 1 : 0 }} />

                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                    {/* <List sx={{ p: 0 }}>

                                    <ListItem disablePadding sx={{ display: 'block' }}>
                                        <ListItemButton
                                            sx={{
                                                minHeight: 48,
                                                justifyContent: open ? 'initial' : 'center',
                                                px: 2.5,
                                                backgroundColor: pathurl === "package-details" ? "#8080801c" : "none"
                                            }}
                                            onClick={() => handleListItemClick("package-details")}
                                        >
                                            <ListItemIcon
                                                sx={{
                                                    minWidth: 0,
                                                    mr: open ? 3 : 'auto',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <RiLiveLine />
                                            </ListItemIcon>
                                            <ListItemText primary={"Package Details"} sx={{ opacity: open ? 1 : 0 }} />
                                        </ListItemButton>
                                    </ListItem>

                                </List> */}
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "start-test" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("start-test")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <MdNewspaper />
                                                </ListItemIcon>
                                                <ListItemText primary={"Test Paper"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "test-results" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("test-results")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <AiOutlineDatabase />
                                                </ListItemIcon>
                                                <ListItemText primary={"Test Results"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                </div>
                            )}
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "liveclasses" ? "#8080801c" : "none"
                                }}
                                // onClick={() => handleListItemClick1("liveclasses")}
                                 onClick={() => handleListItemClick("live-classes-package-details")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <RiLiveLine />
                                </ListItemIcon>
                                <ListItemText primary={"Live Classes"} sx={{ opacity: open ? 1 : 0 }} />
                                {/* <ExpandMoreIcon
                                    sx={{
                                        transform: openItem === "liveclasses" ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.3s ease',
                                        marginLeft: 'auto'
                                    }}
                                /> */}
                            </ListItemButton>
                            {openItem === "liveclasses" && (
                                <div className='testseries-subcategory-drawer' style={{ marginLeft: "30px" }}>
                                    {/* <List sx={{ p: 0 }}>

                                    <ListItem disablePadding sx={{ display: 'block' }}>
                                        <ListItemButton
                                            sx={{
                                                minHeight: 48,
                                                justifyContent: open ? 'initial' : 'center',
                                                px: 2.5,
                                                backgroundColor: pathurl === "package-test-series" ? "#8080801c" : "none"
                                            }}
                                            onClick={() => handleListItemClick("live-class")}
                                        >
                                            <ListItemIcon
                                                sx={{
                                                    minWidth: 0,
                                                    mr: open ? 3 : 'auto',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <RiLiveLine />
                                            </ListItemIcon>
                                            <ListItemText primary={"Live Classes"} sx={{ opacity: open ? 1 : 0 }} />
                                        </ListItemButton>
                                    </ListItem>

                                </List> */}
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "live-classes-package-details" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("live-classes-package-details")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <TfiPackage />
                                                </ListItemIcon>
                                                <ListItemText primary={"Package Details"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "test-results" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("live-class-manage-schedule")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <RiLiveLine />
                                                </ListItemIcon>
                                                <ListItemText primary={"Class & Schedule"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                    {/* <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "call-history" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("call-history")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <RiLiveLine />
                                                </ListItemIcon>
                                                <ListItemText primary={"Previous Classes"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List> */}


                                </div>
                            )}
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "teacheroncall" ? "#8080801c" : "none"
                                }}
                                // onClick={() => handleListItemClick1("teacheroncall")}
                                onClick={() => handleListItemClick("teacheroncall/package-details")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <FaRocketchat />
                                </ListItemIcon>
                                <ListItemText primary={"Teacher on Calls"} sx={{ opacity: open ? 1 : 0 }} />
                                {/* <ExpandMoreIcon
                                    sx={{
                                        transform: openItem === "teacheroncall" ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.3s ease',
                                        marginLeft: 'auto'
                                    }}
                                /> */}
                            </ListItemButton>
                            {openItem === "teacheroncall" && (
                                <div className='testseries-subcategory-drawer' style={{ marginLeft: "30px" }}>

                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "package-details" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("teacheroncall/package-details")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <RiLiveLine />
                                                </ListItemIcon>
                                                <ListItemText primary={"Package Details"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "test-paper" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("teacheroncall/call-history")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <RiLiveLine />
                                                </ListItemIcon>
                                                <ListItemText primary={"Call History"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>

                                </div>
                            )}
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "interview-package-details" ? "#8080801c" : "none"
                                }}
                                // onClick={() => handleListItemClick1("interview")}
                                onClick={() => handleListItemClick("interview-package-details")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <MdLiveHelp />
                                </ListItemIcon>
                                <ListItemText primary={"Interviews"} sx={{ opacity: open ? 1 : 0 }} />
                                {/* <ExpandMoreIcon
                                    sx={{
                                        transform: openItem === "interview" ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.3s ease',
                                        marginLeft: 'auto'
                                    }}
                                /> */}
                            </ListItemButton>
                            {openItem === "interview" && (
                                <div className='testseries-subcategory-drawer' style={{ marginLeft: "30px" }}>
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "package-test-series" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("interview-package-details")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <RiLiveLine />
                                                </ListItemIcon>
                                                <ListItemText primary={"Package Details"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                    {/* <List sx={{ p: 0 }}>

                                    <ListItem disablePadding sx={{ display: 'block' }}>
                                        <ListItemButton
                                            sx={{
                                                minHeight: 48,
                                                justifyContent: open ? 'initial' : 'center',
                                                px: 2.5,
                                                backgroundColor: pathurl === "package-details" ? "#8080801c" : "none"
                                            }}
                                            onClick={() => handleListItemClick("manage-sechedule")}
                                        >
                                            <ListItemIcon
                                                sx={{
                                                    minWidth: 0,
                                                    mr: open ? 3 : 'auto',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <RiLiveLine />
                                            </ListItemIcon>
                                            <ListItemText primary={"Manage Schedule"} sx={{ opacity: open ? 1 : 0 }} />
                                        </ListItemButton>
                                    </ListItem>

                                </List> */}
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "test-paper" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("my-interview")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <RiLiveLine />
                                                </ListItemIcon>
                                                <ListItemText primary={"My Interviews"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                    <List sx={{ p: 0 }}>

                                        <ListItem disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: open ? 'initial' : 'center',
                                                    px: 2.5,
                                                    backgroundColor: pathurl === "test-results" ? "#8080801c" : "none"
                                                }}
                                                onClick={() => handleListItemClick("interview-history")}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: open ? 3 : 'auto',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <RiLiveLine />
                                                </ListItemIcon>
                                                <ListItemText primary={"Interview History"} sx={{ opacity: open ? 1 : 0 }} />
                                            </ListItemButton>
                                        </ListItem>

                                    </List>
                                </div>
                            )}
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "wallet" ? "#8080801c" : "none"
                                }}
                                onClick={() => handleListItemClick("wallet")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <FaWallet />
                                </ListItemIcon>
                                <ListItemText primary={"Wallet"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>
                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "My-Referral" ? "#8080801c" : "none"
                                }}
                                onClick={() => handleListItemClick("My-Referral")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <FaWallet />
                                </ListItemIcon>
                                <ListItemText primary={"My Referral"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "feedback" ? "#8080801c" : "none"
                                }}
                                onClick={() => handleListItemClick("feedback")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <MdFeedback />
                                </ListItemIcon>
                                <ListItemText primary={"Feedback and Reviews"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>

                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: pathurl === "help-support" ? "#8080801c" : "none"
                                }}
                                onClick={() => handleListItemClick("help-support")}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <HiSupport />
                                </ListItemIcon>
                                <ListItemText primary={"Help & Support"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>



                    <List sx={{ p: 0 }}>

                        <ListItem disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    // backgroundColor: pathurl === "student-profile" ? "#8080801c": "none"
                                }}
                                onClick={() => removelocaldata()}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 1 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <LuLogOut />
                                </ListItemIcon>
                                <ListItemText primary={"Logout"} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>

                    </List>



                </Drawer>
                {/* <Box component="main" sx={{ flexGrow: 1, p: 3, backgroundColor: "#7793c514", height: "auto" }}>
                <DrawerHeader />
                {getContent()}
            </Box> */}
            </Box>
        </div>
    );
}